import { Component, EventEmitter, Output } from '@angular/core'

import { DatabaseObject } from '../../objects'
import { SessionService } from '../../services/session.service'

@Component({
  selector: 'app-ecolog-filter',
  templateUrl: './ecolog-filter.component.html',
  styleUrls: ['../../generic-filter/generic-filter.component.css']
})
export class EcologFilterComponent {

  @Output() filterChange = new EventEmitter()

  constructor(protected sessionService: SessionService) { }

  onClient(client: DatabaseObject | null) { this.filterChange.emit({ clientId: client ? client.id : null }) }

  onStatus(status: string) { this.filterChange.emit({ status: status }) }
}
